import * as React from "react";
import { cn } from "@/lib/utils";

export type NeonButtonVariant = "primary" | "secondary" | "ghost";

export interface NeonButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: NeonButtonVariant;
  fullWidth?: boolean;
}

export const NeonButton = React.forwardRef<HTMLButtonElement, NeonButtonProps>(
  ({ className, variant = "primary", fullWidth = false, ...props }, ref) => {
    const base = "relative inline-flex items-center justify-center gap-2 rounded-xl font-bold uppercase tracking-wider transition-all duration-300 ease-cinematic focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-lime overflow-hidden";
    const variants: Record<NeonButtonVariant, string> = {
      primary:
        "bg-[linear-gradient(135deg,#D7FF32_0%,#A0FF00_100%)] text-black shadow-glow hover:shadow-glow-strong px-8 py-4 text-base",
      secondary:
        "border-2 border-brand-lime text-brand-lime hover:bg-brand-lime hover:text-black px-8 py-4 text-base",
      ghost: "text-brand-lime hover:text-white hover:bg-brand-lime/10 px-6 py-3 text-base",
    };

    return (
      <button
        ref={ref}
        className={cn(base, variants[variant], fullWidth && "w-full", className)}
        {...props}
      />
    );
  }
);

NeonButton.displayName = "NeonButton";

export default NeonButton;


